
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 42 26","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"42","height":"26","data-name":"Vector Smart Object","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAaCAQAAABrsAZ9AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfkBwcLEB7SbtdOAAACW0lEQVRIx62UTUhUYRSGnztlJjk0/ivNwgSJgqkgS8EKCmohJkkU/YGLCoKWWgQGtooghsBCKQoM1E0oYUZQUUYgERhGPwuxQXCR5cw40Ui20LfF3IZ7R6/eMd9v8817vvvMufc75yBcrBx1aUYz6lKOm/Me3KiHaYooYpoeV+dd/HNAIXmEkEchBVYm0wJGmQNgjlEKln5g9TzH4CDbybI469jDgLmv5AN7LbHfDPMMpSBSfq+nDx/PidvcAHnmLsJHWySbA8So4+di0PsYnDVf1p083EOccb6oDMXlc1Vk1uVTXBnOF+VnglgaWSYUYwK/PXmr8okk9xlpYCPkO0NziSa+NEHivGebLVrFG0K0kTsPGrV7qdAIYNDGbkq4xQv2JWNbeUw7taximIDpldPMFbxEFodGyaaDao5zkTAn6KUegEw6ucQ0p7lNMy+pxqCFtxRSwYPUTO3FP8d+RnhFDT2McZK71NLLDu5wlTHWcpNuBmiigUeM84cAPmK8I5uwjWMrjjVqUIXKNKR2GfLrs4Lyq1vf9VA7FVa50GaN67L8qlOx+vRDX3VKUquVY4ce0WHd0JSaZAihAg3qiTYIFeuTLpin/PqiTh1TSK3KUp8aVa1DztAODSuoUouTqWua0pCiarG4Xl3XUx0VQpsU1nltdIb2q2aBjvFqlwoX6agqvVa/M3RQlWk3aQI76Nym/4o/XS1Zp8vRAnXqTU7LPLakDlxXMsijNJn1L0PnCJr5eShZVp4JfTOncC6NKKqyZV2O0ypT1MOsfWz9t/KZRfWa1EpqUvV/Ab/rV5POuVoTAAAAAElFTkSuQmCC"}})])
          )
        }
      }
    